










import { Vue, Component } from 'vue-property-decorator';
import { VueLoading } from 'vue-loading-template';

@Component({
  components: {
    VueLoading,
  },
})
export default class Loading extends Vue {}
